import { render, staticRenderFns } from "./TheScreenshotButton.vue?vue&type=template&id=651f47f8&scoped=true&lang=html&"
import script from "./TheScreenshotButton.vue?vue&type=script&lang=ts&"
export * from "./TheScreenshotButton.vue?vue&type=script&lang=ts&"
import style0 from "./TheScreenshotButton.vue?vue&type=style&index=0&id=651f47f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651f47f8",
  null
  
)

export default component.exports